
import React,{
    useState, useEffect
} from 'react'

import { toast } from "react-toastify";

import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML } from "draft-convert";
import draftToHtml from 'draftjs-to-html'; // Para convertir el contenido a HTML
import htmlToDraft from 'html-to-draftjs'; // Para convertir HTML a contenido de Draft.js
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// components
import {
    Row, 
    Col, 
    Modal, 
    Button,
    Form
} from 'react-bootstrap';
import {
    FaTwitter,
    FaFacebook,
    FaLinkedin,
    FaOrcid,
    FaBoxTissue,
    FaAt
} from "react-icons/fa";

import { format } from 'date-fns'
//style
import "../style.css";

import { getAuthor, updateAuthor, createAuthor, deleteAuthor } from "../../../api/authors";
// import { useNavigate } from "react-router-dom";
// import { useAppStore } from '../../../context/state'

const Dialog = (props) =>{
    
    // const { show, handleClose, lang, current, onFinish } = props;
    const { show, handleClose, current, onFinish } = props;

    const defaultValues ={
        active:true,
        _id:"",
        id:"",
        firstName:"",
        lastName:"",
        gclientId:'',
        fclientId:'',
        editor:'',
        email:'editorial.humanidades@correounivalle.edu.co',
        createdAt:'',
        academictitle:'',
        updatedAt:new Date().toISOString().slice(0, 10),
        image:'',
        link:'',
        facebook: "https://www.facebook.com/",
        twitter: "https://www.twitter.com/",
        linkedin: "https://www.linkedin.com/in/",
        orcid: "https://orcid.org/my-orcid?orcid=",
        cvlac:"https://scienti.minciencias.gov.co/cvlac/visualizador/generarCurriculoCv.do?cod_rh=",
        homepage: "",
        birthDate:"" ,//new Date().toISOString().slice(0, 10),

        birthDay:"",//new Date().getDate(),
        birthMonth:"",//new Date().getMonth(),
        birthYear:"", //new Date().getFullYear(),

        birthPlace:"",
        photo:"/assets/app/author.png",
        image_file: null,
        image_preview: '',
        papers:"",
        research:"",
        membership:"",
        description:""
    }
    const [formData, setFormData] = useState(defaultValues)
    // eslint-disable-next-line no-unused-vars
    const [isValid, setValidate] = useState(true)
    

    const [preview, setPreview] = useState(defaultValues.photo);
    const [file, setFile] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [isMounted, setIsMounted] = useState(false)

    const [editDesctiption, setDescriptionState] = useState(() =>{
        if(!isMounted) return;
        return EditorState.createEmpty()
    });
    
    const editorChange = (state) => {
        setDescriptionState(state);
        let data = {
            "description": draftToHtml(convertToRaw(editDesctiption.getCurrentContent()))
        }
        setFormData({
            ...formData,
            ...data})
        return data;
    };

    const [editPapers, setAuthorPapers] = useState(() =>{
        if(!isMounted) return;
        return EditorState.createEmpty()
    });
    
    const editorPaperChange = (state) => {
        setAuthorPapers(state);
        let data = {
            "papers": draftToHtml(convertToRaw(editPapers.getCurrentContent()))
        }
        setFormData({
            ...formData,
            ...data})
        return data;
    };

    const reload = (current)=>{
        if(!current) return;
        getAuthor(current._id)
            .then((response)=>{
                const { data } = response
                setFormData({
                    ...formData,
                    ...current,
                    ...data, 
                    ...{
                        'id':data._id,
                        birthYear:data.birthDate.split("-")?.[0] || "",
                        birthMonth:data.birthDate.split("-")?.[1] || "",
                        birthDay:data.birthDate.split("-")?.[2] || "",
                        createdAt: format(new Date(data.createdAt), 'yyyy-MM-dd'),
                        updatedAt: format(new Date(data.updatedAt), 'yyyy-MM-dd')
                    }
                })
                setPreview(current.photo)
            })
            .catch((error)=>{

            })
    }
    
    function previewImage(e) {
        setPreview(URL.createObjectURL(e.target.files[0]));
        setFile(e.target.files[0]);
    }
    
    function createEditorStateFromHTML(html) {
        const blocksFromHTML = htmlToDraft(html);
        const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
        return EditorState.createWithContent(contentState);
    }   
    
    useEffect(() => {
        if(!current){
            setFormData({...defaultValues});
            setPreview(defaultValues.photo);

            setDescriptionState(EditorState.createWithContent(convertFromHTML(`<span></span>`))) ;
            setAuthorPapers(EditorState.createWithContent(convertFromHTML(`<span></span>`)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[show])

    useEffect(() => {
        if(current){
            reload(current)
        }else{
            setFormData({...defaultValues});
            setPreview(defaultValues.photo)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[current])

    useEffect(() => {
        if(!current) return;
        try {
            // setDescriptionState(EditorState.createWithContent(convertFromHTML(current.description))) 
            const editorState = createEditorStateFromHTML(current.description);
            setDescriptionState(editorState);

        } catch (error) {
            // setDescriptionState(EditorState.createWithContent(convertFromHTML(`<span>${current.description}</span>`)))
            const editorState = createEditorStateFromHTML('<span> </span>');
            setDescriptionState(editorState);
        }

        try {
            const editorState = createEditorStateFromHTML(current.papers);
            setAuthorPapers(editorState);
        } catch (error) {
            // setAuthorPapers(EditorState.createWithContent(convertFromHTML(`<span>${current.papers}</span>`)))
            const editorState = createEditorStateFromHTML('<span> </span>');
            setAuthorPapers(editorState);

        }
    },[current])

    const handleOnchange = (event) => {
        const {
            name,
            value
        } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    
    const handleContentClick = (e) => {
        // Maneja el evento de clic en el contenido del editor
        let data = {
            "papers": draftToHtml(convertToRaw(editPapers.getCurrentContent()))
        }
        setFormData({
            ...formData,
            ...data})
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!isValid) return;
        if (file !== null) formData['image_file'] = file;
        // addNewLine(editDesctiption, setDescriptionState);
        // addNewLine(editPapers, setAuthorPapers);
    
        if(current){

            const dates = [formData.birthYear, formData.birthMonth, formData.birthDay].filter(valor => valor !== null && valor !== undefined && valor !== "");
            const fulldate = dates.join('-');
            formData.birthDate = fulldate

            updateAuthor(formData._id, {
                ...formData,
                ...editorChange(editDesctiption),
                ...editorPaperChange(editPapers)
            }).then(res=>{
                // TODO: update item storage
                onFinish({...res, update:true});
                handleClose();
                toast.success(`¡El autor ha sido actualizado!`,{
                    position: toast.POSITION.TOP_RIGHT,
                    className: "foo-bar",
                    autoClose: 4000,
                    pauseOnHover: false,
                });
            }).catch(err=>{
                toast.warning("Ha fallado la actualización del usuario!",{
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                    pauseOnHover: false,
                });
            })
            return;
        }
        createAuthor(formData).then(res=>{
            onFinish({...res, create:true});
            handleClose();
            toast.success(`¡El autor ha sido creado!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
                autoClose: 4000,
                pauseOnHover: false,
            });
        }).catch(err=>{
            toast.warning("Ha fallado la creación del usuario!",{
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 4000,
                pauseOnHover: false,
            });
        })
        return;
    }
    
    const removeImage = () =>{
        setFile(null)
        setPreview("/assets/app/author.png")
        setFormData({
            ...formData,
            ...{'image_file':null,"photo":"/assets/app/author.png"}
        });
        updateAuthor(formData._id, formData).then(res=>{
            // TODO: update item storage
            onFinish(res);
            handleClose();
            toast.success(`¡El autor ha sido actualizado!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
                autoClose: 4000,
                pauseOnHover: false,
            });
        }).catch(err=>{
            toast.warning("Ha fallado la actualización del usuario!",{
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 4000,
                pauseOnHover: false,
            });
        })
    }

    const removeAuthor = () =>{

        if(!Boolean(formData._id)){
            toast.success(`¡El autor ha sido eliminado!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
                autoClose: 4000,
                pauseOnHover: false,
            });
            handleClose();
            return null;
        }

        deleteAuthor(formData._id).then(res=>{
            toast.success(`¡El autor ha sido eliminado!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
                autoClose: 4000,
                pauseOnHover: false,
            });
            onFinish({data:{"_id":formData._id}, delete:true});
            handleClose();
            return null;
            
        }).catch(err=>{
            toast.warning("Ha fallado la actualización del usuario!",{
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 4000,
                pauseOnHover: false,
            });
            return null;
        });
    }


    return(
        <Modal id="dialogauthor" show={show} onHide={handleClose}>
            <Modal.Header style={{
                display:'flex',
                justifyContent:'space-between'
            }}>
                <Modal.Title>Panel de autores</Modal.Title>
                <div className="" role="group">
                    <Button size="sm" variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button> {' '}
                    <Button size="sm" variant="primary" type="submit" onClick={handleSubmit}>
                        Guardar cambios
                    </Button>
                </div>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                <input type="hidden" name="id" id="id" value={formData._id}/>
                <Row>
                    <Col sm={9} md={9}>
                        <Row>
                            <Col>
                                <Form.Group controlId="firstName">
                                <Form.Label>Nombres (*)</Form.Label>
                                <Form.Control
                                    name={'firstName'}
                                    defaultValue={formData.firstName}
                                    onChange={handleOnchange}
                                    placeholder=""
                                    required
                                ></Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="lastName">
                                <Form.Label>Apellidos(*) </Form.Label>
                                <Form.Control
                                    name={'lastName'}
                                    defaultValue={formData.lastName}
                                    onChange={handleOnchange}
                                    placeholder=""
                                    required
                                ></Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={6}>
                                <Form.Group controlId="email">
                                    <Form.Label>Correo público del autor</Form.Label>
                                    <Form.Control
                                        name={'email'}
                                        defaultValue={formData.email}
                                        onChange={handleOnchange}
                                        type="email"
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12} md={6}>
                                <Form.Group controlId="gender">
                                    <Form.Label>Sexo</Form.Label>
                                    <select 
                                        className="form-control" 
                                        name='gender'
                                        onChange={handleOnchange} 
                                        defaultValue={formData.gender}>
                                        <option value="unselected" >No definido</option>
                                        <option value="female" >Femenino</option>
                                        <option value="male" >Masculino</option>
                                        <option value="nobinary" >No binario</option>
                                    </select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <Form.Label>Fecha de nacimiento</Form.Label>
                                    <Col sm={4} md={3}>
                                        <Form.Group controlId="birthDay">
                                            <Form.Control
                                                name={'birthDay'}
                                                className="w-100"
                                                value={formData.birthDay}
                                                onChange={handleOnchange}
                                                min={1}
                                                max={31} 
                                                type="number"
                                                placeholder="Día"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} md={3}>
                                        <Form.Group controlId="birthMonth">
                                            <Form.Control
                                                name={'birthMonth'}
                                                className="w-100"
                                                value={formData.birthMonth}
                                                onChange={handleOnchange}
                                                min={1}
                                                max={12}
                                                type="number"
                                                placeholder="Mes"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} md={3}>
                                        <Form.Group controlId="birthYear">
                                            <Form.Control
                                                name={'birthYear'}
                                                className="w-100"
                                                value={formData.birthYear}
                                                onChange={handleOnchange}
                                                type="number"
                                                placeholder="Año"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Form.Group controlId="birthPlace">
                                <Form.Label>Lugar de nacimiento</Form.Label>
                                <Form.Control
                                    name={'birthPlace'}
                                    value={formData.birthPlace}
                                    onChange={handleOnchange}
                                    placeholder="Pais, Departamento, Ciudad"
                                />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Group controlId="university">
                                <Form.Label>Autoría/filiación</Form.Label>
                                <Form.Control
                                    name={'university'}
                                    defaultValue={formData.university}
                                    onChange={handleOnchange}
                                    placeholder="Universidad del valle"
                                    required                          
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group controlId="academictitle">
                                <Form.Label>Formación académica</Form.Label>
                                <Form.Control
                                    name={'academictitle'}
                                    defaultValue={formData.academictitle}
                                    onChange={handleOnchange}
                                    placeholder="Doctor en filosofía"
                                    required                          
                                />
                            </Form.Group>
                        </Row>
                            <Row>
                                <Form.Group controlId="description">
                                    <Form.Label>Descripción</Form.Label>
                                    {show && <Editor
                                        editorState={editDesctiption}
                                        onEditorStateChange={editorChange}
                                        wrapperClassName="author-editor-wrapper"
                                        editorClassName="author-editor"
                                    /> }
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group controlId="description">
                                    <Form.Label>Artículos</Form.Label>
                                    {show && <Editor
                                        editorState={editPapers}
                                        onEditorStateChange={editorPaperChange}
                                        onContentStateChange={handleContentClick}
                                        wrapperClassName="author-editor-wrapper"
                                        editorClassName="author-editor"
                                    /> }
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group controlId="research">
                                    <Form.Label>Lineas de investigación</Form.Label>
                                    <Form.Control
                                        name={'research'}
                                        defaultValue={formData.research}
                                        onChange={handleOnchange}
                                        placeholder="Constitución del sujeto y modernidad; Identidad, justicia y reconocimiento; Otras"
                                        required                          
                                    />
                                 </Form.Group>
                            </Row>
                        <Row>

                        </Row>
                        <Row>
                        <Form.Group controlId="facebook">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaFacebook />
                            </span>
                            <Form.Control
                                name={'facebook'}
                                defaultValue={formData.facebook}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Perfil de facebook"
                            />
                            </div>
                        </Form.Group>
                        <Form.Group controlId="twitter">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaTwitter />
                            </span>
                            <Form.Control
                                name={'twitter'}
                                defaultValue={formData.twitter}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Perfil de facebook"
                            />
                            </div>
                        </Form.Group>

                        <Form.Group controlId="linkedin">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaLinkedin />
                            </span>
                            <Form.Control
                                name={'linkedin'}
                                defaultValue={formData.linkedin}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Perfil de linkein"
                            />
                            </div>
                        </Form.Group>

                        <Form.Group controlId="orcid">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaOrcid />
                            </span>
                            <Form.Control
                                name={'orcid'}
                                defaultValue={formData.orcid}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Perfil de ORCID"
                            />
                            </div>
                        </Form.Group>

                        <Form.Group controlId="cvlac">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaBoxTissue />
                            </span>
                            <Form.Control
                                name={'cvlac'}
                                defaultValue={formData.cvlac}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Perfil de CVLAC"
                            />
                            </div>
                        </Form.Group>

                        <Form.Group controlId="homepage">
                            <div className="input-group mb-3">
                            <span className="input-group-text">
                                <FaAt />
                            </span>
                            <Form.Control
                                name={'homepage'}
                                defaultValue={formData.homepage}
                                onChange={handleOnchange}
                                type="text"
                                placeholder="Página principal del autor"
                            />
                            </div>
                        </Form.Group>
                        </Row>
                    </Col>
                    <Col sm={12} md={3} style={{
                        "display": 'flex',
                        "flexDirection": 'column',
                        "alignItems": 'center'
                    }}>
                        <img
                            className="img-fluid img-thumbnail mb-3"
                            src={preview}
                            alt="author-pic"
                            style={{ maxHeight:"300px", minHeight:"200px" }}
                        />
                        <Form.Control
                            className='mb-2'
                            size="sm"
                            onChange={previewImage}
                            type="file"
                            accept="image/*"
                            placeholder="Imagen"
                        />
                        <span 
                            className='btn btn-secondary btn-block btn-sm' 
                            style={{ width:'100%' }}
                            onClick={removeImage}
                        >
                            Eliminar imagen
                        </span>
                        <span 
                            className='btn btn-warning btn-block btn-sm' 
                            style={{ width:'100%' }}
                            onClick={removeAuthor}
                        >
                            Eliminar autor
                        </span>
                    </Col>
                </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button size="sm" variant="primary" type="submit">
                        Guardar cambios
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
};

export default Dialog;